import React from 'react';
import "./sustainability.css"
const Sustainability = () => {
    return (
        <div className="section1" style={{ backgroundColor: '#85e69a6c' }} id="sustain">
            <div className="contentt">
                <div className="section-title">Environmental Impact</div>
                <div className="section-heading">Our Commitment to Sustainability</div>
                <div className="section-subheading">
                    We're dedicated to reducing environmental impact through innovative waste management practices and sustainable solutions.
                </div>
            </div>
            <div className="impact-stats">
                <div className="impact-stat"><h3>85%</h3><p>Recycling Rate</p></div>
                <div className="impact-stat"><h3>50K</h3><p>Tons of Waste Managed</p></div>
                <div className="impact-stat"><h3>30%</h3><p>Reduction in Landfill Waste</p></div>
            </div>
        </div>
    );
};

export default Sustainability;